export interface GuideStep {
  step: string;
  icon: string;
  title: string;
  desc: string;
  points: string[];
}

export const watchSteps: GuideStep[] = [
  {
    step: '01',
    icon: 'ri-search-eye-line',
    title: '先找到想看的片子',
    desc: '用顶部导航或分类片库，按类型、年份、地区快速定位，也可以直接搜索片名关键字。',
    points: ['支持片名关键字搜索', '按类型与年份筛选', '每周更新的榜单可直接参考'],
  },
  {
    step: '02',
    icon: 'ri-hd-line',
    title: '选好清晰度与线路',
    desc: '同一部作品通常提供多条播放线路，网络不同可自行切换，选择最流畅的一条即可。',
    points: ['多线路自动备份', '标清 / 高清 / 超清可选', '弱网环境自动降档'],
  },
  {
    step: '03',
    icon: 'ri-play-circle-line',
    title: '直接在线播放',
    desc: '无需注册即可观看，进度会自动记录在本机，下次打开可以从上次的位置继续。',
    points: ['免登录直接播放', '断点续看自动记录', '全屏与倍速可调'],
  },
  {
    step: '04',
    icon: 'ri-cast-line',
    title: '投到更大的屏幕',
    desc: '想在大屏观影，可把手机或电脑画面投到电视，享受更沉浸的观影体验。',
    points: ['支持主流投屏协议', '大屏适配画面比例', '适合与家人一起观看'],
  },
];